export const getAllParkingBaySuccess = 'GET_ALL_ParkingBay_SUCCESS';
export const getAllParkingBayFailure = 'GET_ALL_ParkingBay_FAILURE';
export const addNewParkingBaySuccess = 'ADD_NEW_PARKING_BAY_SUCCESS';
export const addNewParkingBayFailure = 'ADD_NEW_PARKING_BAY_FAILURE';
export const deleteParkingBaySuccess = 'DELETE_PARKING_BAY_SUCCESS';
export const deleteParkingBayFailure = 'DELETE_PARKING_BAY_FAILURE';
export const editParkingBaySuccess = 'EDITPARKING_BAY_SUCCESS';
export const editParkingBayFailure = 'EDIT_PARKING_BAY_FAILURE';